//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common_utils from './_house_item_utils.js'
export default {
    mixins: [
        common_utils
    ],
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
}
